import { getWhiteShops } from '@/apis/shop'
import { ref } from 'vue'

export const useChoiceWhiteShops = () => {
  const ids = getWhiteShops().then((res:any) => {
    return res.data?.map((v: any) => v.customerShopId)
  })
  return (shop:any) => {
    ids.then((ids) => {
      if (ids?.includes(shop.customerShopId)) {
        shop.supportChoice = 1
      }
    })
    return true
  }
}
